import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '../../../../components/Box';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import { Helpers } from '../../../../helpers/Helpers';
import { GetAmbarByIdResponseAmbarExpectedIncomeOutcome } from '../../../../models/response/ambar/GetAmbarByIdResponse';
import { GetServiceListResponseData } from '../../../../models/response/service/GetServiceListResponse';
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../../redux/reducers/authSlice';
import { ConstantService } from '../../../../services/ConstantService';
import { ServiceService } from '../../../../services/ServiceService';
import { KTCard } from '../../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';
import toast from "react-hot-toast";
import { GetServiceByIdResponse } from '../../../../models/response/service/GetServiceByIdResponse';
import { RootState } from '../../../../redux/store';
import FindPriceModal from './FindPriceModal';
import { GetAmbarListResponseAmbarExpectedIncomeOutcome } from '../../../../models/response/ambar/GetAmbarListResponse';
import { aciklamaVeSeferNotu } from '../../../../helpers/seferFiyat';

interface Props {
    expectedIncomeRef: any
    expectedIncomes: GetAmbarByIdResponseAmbarExpectedIncomeOutcome[]
    setExpectedIncomes: React.Dispatch<React.SetStateAction<GetAmbarByIdResponseAmbarExpectedIncomeOutcome[]>>
    isIncome: boolean
    trCurrency: CustomSingleSelectModel | undefined
    selectedPo: CustomSingleSelectModel | undefined
    /** Siparişin kimliği. Kaydedilmemiş siparişte Fiyat Bul çalışamaz. */
    ambarId: string | undefined
    /** Pencere sunucuya yazdiktan sonra cagrilir; siparisin saklanan surumu tazelenir (#424). */
    onSunucuyaYazildi?: () => void
}

const AmbarExpectedIncomeOutcome = ({
    expectedIncomeRef,
    expectedIncomes,
    setExpectedIncomes,
    isIncome,
    trCurrency,
    selectedPo,
    ambarId,
    onSunucuyaYazildi
}: Props) => {
    const auth = useSelector((state: RootState) => state.auth)
    const dispatch = useDispatch();
    const [fiyatBulAcik, setFiyatBulAcik] = useState(false);

    // Fiyat bulma siparişin kayıtlı alanlarına (güzergâh, araç, müşteri) bakar ve satırı
    // doğrudan siparişe yazar; bu yüzden sipariş kaydedilmeden çalışamaz.
    // Gider tarafı bu turda kapsam dışı.
    const fiyatBulAktif = isIncome && !Helpers.isEmpty(ambarId);

    const fiyatBulIpucu = !isIncome
        ? 'Fiyat bulma şimdilik yalnız Beklenen Gelir tarafında çalışıyor.'
        : (Helpers.isEmpty(ambarId) ? 'Önce siparişi kaydedin.' : undefined);

    /** Pencerede kaydedilen satırlar listeye eklenir; sunucuya zaten yazıldılar. */
    const fiyatSatirlariEklendi = (yeniSatirlar: GetAmbarListResponseAmbarExpectedIncomeOutcome[], guncellenenler: GetAmbarListResponseAmbarExpectedIncomeOutcome[]) => {
        const ekranSatiri = function (x: GetAmbarListResponseAmbarExpectedIncomeOutcome): GetAmbarByIdResponseAmbarExpectedIncomeOutcome {
            return {
                ambarExpectedIncomeOutcomeId: x.ambarExpectedIncomeOutcomeId,
                isIncome: x.isIncome,
                serviceId: x.serviceId,
                serviceName: x.serviceName,
                unitPrice: x.unitPrice,
                quantity: x.quantity,
                currencyTypeId: x.currencyTypeId,
                currencyTypeName: x.currencyTypeName,
                taxRate: x.taxRate,
                totalPrice: x.totalPrice?.toString(),
                taxPrice: x.taxPrice,
                totalWithoutTaxPrice: x.totalWithoutTaxPrice?.toString(),
                currency: x.currency,
                description: x.description,
                invoiceNo: x.invoiceNo,
                isApproved: x.isApproved,
                isSelected: false,
                seferHesabiAmbarId: x.seferHesabiAmbarId,
                seferHesabiRefNo: x.seferHesabiRefNo,
                seferHesabiTarihiStr: x.seferHesabiTarihiStr
            }
        };

        // Sefer satiri sunucuda guncellendiyse ekrandaki eski tutar yenisiyle degisir (Kaydet eskiyi geri yazmasin).
        setExpectedIncomes([
            ...expectedIncomes.map(function (x) {
                var yeni = guncellenenler.find(g => g.ambarExpectedIncomeOutcomeId == x.ambarExpectedIncomeOutcomeId);
                return yeni ? ekranSatiri(yeni) : x;
            }),
            ...yeniSatirlar.map(ekranSatiri)
        ]);

        // Satirlar sunucuya yazildi: siparisin surumu degisti; saklanan surum tazelenmezse sonraki Kaydet engellenir (#424).
        onSunucuyaYazildi?.();
    }
    const [selectedService, setSelectedService] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [unitPrice, setUnitPrice] = useState<string | undefined>(undefined);
    const [quantity, setQuantity] = useState<string | undefined>('1');
    const [selectedCurrencyType, setSelectedCurrencyType] = useState<CustomSingleSelectModel | undefined>(trCurrency);
    const [taxRate, setTaxRate] = useState<string | undefined>(undefined);
    const [currency, setCurrency] = useState<string | undefined>(undefined);
    const [description, setDescription] = useState<string | undefined>(undefined);
    const [invoiceNo, setInvoiceNo] = useState<string | undefined>(undefined);
    const [invoiceDate, setInvoiceDate] = useState<string | undefined>(undefined);
    const [expectedIncomeId, setExpectedIncomeId] = useState<string | undefined>(undefined);
    const [isApproved, setIsApproved] = useState<boolean | undefined>(undefined);
    const [isOpen, setIsOpen] = useState(false);

    const setUpdateItem = () => {
        var o = expectedIncomes.filter(x => x.isSelected)[0];

        setExpectedIncomeId(o.ambarExpectedIncomeOutcomeId);
        setSelectedService(o.serviceId ? { label: o.serviceName + '', value: o.serviceId } : undefined);
        setUnitPrice(o.unitPrice);
        setQuantity(o.quantity);
        setSelectedCurrencyType(o.currencyTypeId ? { label: o.currencyTypeName + '', value: o.currencyTypeId } : undefined);
        setTaxRate(o.taxRate)
        setCurrency(o.currency);
        setDescription(o.description);
        setInvoiceNo(o.invoiceNo);
        setInvoiceDate(o.invoiceDate);
        setIsApproved(o.isApproved);
        setIsOpen(true);
        scrollTo();
    }

    const controlFields = async () => {
        if (!isIncome || !selectedPo)
            return;

        if (!auth.user.user?.data.authorizedMenus.find(x => x.menuName == "Genel Tanımlamalar > PO Eşleştirme"))
            return;

        try {
            dispatch(storeActivityIndicator(true));

            var response: GetServiceByIdResponse = await ServiceService.getServiceById(selectedPo.value);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            if (response.data) {
                setTaxRate(response.data.incomePercentageName ?? '');
                setSelectedService({ label: response.data.name, value: response.data.serviceId, additionalValue1: response.data.incomePercentageName });
            }
        }
        catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const cancelAdding = () => {
        if (!isOpen) {
            controlFields();
            setIsOpen(true);
            scrollTo();
            return;
        }

        setExpectedIncomeId('');
        setSelectedService(undefined);
        setUnitPrice('');
        setQuantity('1');
        // setSelectedCurrencyType(trCurrency);
        setTaxRate('');
        setCurrency('');
        setDescription('');
        setInvoiceNo('');
        setInvoiceDate('');
        setIsApproved(undefined);
        setIsOpen(false);
        scrollTo();
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = expectedIncomeRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const deleteItems = () => {
        setExpectedIncomes(expectedIncomes.filter(x => !x.isSelected || x.invoiceId));
    }

    const selectAll = () => {
        var isAllSelected = expectedIncomes.filter(x => !x.invoiceId).length == expectedIncomes.filter(x => x.isSelected && !x.invoiceId).length;

        setExpectedIncomes(expectedIncomes.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const setItemSelected = (_id: string) => {
        setExpectedIncomes(expectedIncomes.map(function (x) {
            if (x.ambarExpectedIncomeOutcomeId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const saveItem = () => {
        if (!selectedService) {
            toast.error('Hizmet Kalemi alanını doldurunuz!')
            return;
        }

        if (Helpers.isEmpty(unitPrice)) {
            toast.error('Birim Fiyat alanını doldurunuz!')
            return;
        }

        if (Helpers.toNumber(unitPrice) <= 0) {
            toast.error("Birim Fiyat 0'dan büyük olmalıdır.")
            return;
        }

        if (Helpers.isEmpty(expectedIncomeId)) {
            var o: GetAmbarByIdResponseAmbarExpectedIncomeOutcome = {
                ambarExpectedIncomeOutcomeId: Helpers.generateUUID(true),
                isSelected: false,
                currency: currency,
                currencyTypeId: selectedCurrencyType?.value,
                currencyTypeName: selectedCurrencyType?.label,
                description: description,
                invoiceDate: invoiceDate,
                invoiceNo: invoiceNo,
                isApproved: isApproved ?? false,
                isIncome: isIncome,
                quantity: quantity,
                serviceId: selectedService?.value,
                serviceName: selectedService?.label,
                taxRate: taxRate,
                unitPrice: unitPrice,
                taxPrice: ((Helpers.toNumber(unitPrice) * Helpers.toNumber(quantity)) * (Helpers.toNumber(taxRate?.toString()?.replace('%', '')) / 100)).toFixed(4),
                totalPrice: ((Helpers.toNumber(unitPrice) * Helpers.toNumber(quantity)) + ((Helpers.toNumber(unitPrice) * Helpers.toNumber(quantity)) * (Helpers.toNumber(taxRate?.toString()?.replace('%', '')) / 100))).toFixed(2),
                totalWithoutTaxPrice: (Helpers.toNumber(unitPrice) * Helpers.toNumber(quantity)).toFixed(2),
            }

            setExpectedIncomes([...expectedIncomes, o])
        }
        else {
            setExpectedIncomes(expectedIncomes.map(function (x) {
                if (x.ambarExpectedIncomeOutcomeId == expectedIncomeId) {
                    x.isSelected = false;
                    x.currency = currency;
                    x.currencyTypeId = selectedCurrencyType?.value;
                    x.currencyTypeName = selectedCurrencyType?.label;
                    x.description = description;
                    x.invoiceDate = invoiceDate;
                    x.invoiceNo = invoiceNo;
                    x.isApproved = isApproved ?? false;
                    x.isIncome = isIncome;
                    x.quantity = quantity;
                    x.serviceId = selectedService?.value;
                    x.serviceName = selectedService?.label;
                    x.taxRate = taxRate;
                    x.unitPrice = unitPrice;
                    x.taxPrice = ((Helpers.toNumber(unitPrice) * Helpers.toNumber(quantity)) * (Helpers.toNumber(taxRate?.toString()?.replace('%', '')) / 100)).toFixed(4);
                    x.totalPrice = ((Helpers.toNumber(unitPrice) * Helpers.toNumber(quantity)) + ((Helpers.toNumber(unitPrice) * Helpers.toNumber(quantity)) * (Helpers.toNumber(taxRate?.toString()?.replace('%', '')) / 100))).toFixed(2);
                    x.totalWithoutTaxPrice = (Helpers.toNumber(unitPrice) * Helpers.toNumber(quantity)).toFixed(2);
                }

                return x;
            }))
        }

        setExpectedIncomeId('');
        setSelectedService(undefined);
        setUnitPrice('');
        setQuantity('1');
        // setSelectedCurrencyType(trCurrency);
        setTaxRate('');
        setCurrency('');
        setDescription('');
        setInvoiceNo('');
        setInvoiceDate('');
        setIsApproved(undefined);
        setIsOpen(false);
        scrollTo();
    }
    return (
        <div className='containerPart' ref={expectedIncomeRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Beklenen {isIncome ? 'Gelir' : 'Gider'}</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Hizmet Kalemi</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedService}
                                                onChange={(selectedItem) => {
                                                    setTaxRate(selectedItem?.additionalValue1 ?? '');
                                                    setSelectedService(selectedItem)
                                                }}
                                                onMenuOpen={() => ServiceService.getServiceList(isIncome)}
                                                labelName='name'
                                                valueName='serviceId'
                                                additionalValue1Name={isIncome ? 'incomePercentageName' : 'outcomePercentageName'}
                                            />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Döviz Cinsi</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedCurrencyType}
                                                onChange={setSelectedCurrencyType}
                                                onMenuOpen={() => ConstantService.getConstantList('CURRENCY', undefined, undefined)}
                                                labelName='additionalValue1'
                                                valueName='constantId'
                                            />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">KDV Tutar</label>
                                            <input style={{ border: '1px solid #F1F1F4' }} value={((Helpers.toNumber(unitPrice) * Helpers.toNumber(quantity)) * (Helpers.toNumber(taxRate?.toString()?.replace('%', '')) / 100)).toFixed(4)} type="number" className="form-control form-control-solid" disabled />
                                        </div>

                                        <div className="mt-5 d-none">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Açıklama</label>
                                            <input style={{ border: '1px solid #F1F1F4' }} value={description} type="text" className="form-control form-control-solid" disabled />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Birim Fiyat</label>
                                            <input style={{ border: '1px solid #F1F1F4' }} value={unitPrice} onChange={(e) => setUnitPrice(e.target.value)} type="number" className="form-control form-control-solid" />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">KDV %</label>
                                            <input style={{ border: '1px solid #F1F1F4' }} value={taxRate} onChange={(e) => setTaxRate(e.target.value)} type="text" className="form-control form-control-solid" disabled />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Brüt Tutar</label>
                                            <input style={{ border: '1px solid #F1F1F4' }} value={((Helpers.toNumber(unitPrice) * Helpers.toNumber(quantity)) + ((Helpers.toNumber(unitPrice) * Helpers.toNumber(quantity)) * (Helpers.toNumber(taxRate?.toString()?.replace('%', '')) / 100))).toFixed(2)} type="number" className="form-control form-control-solid" disabled />
                                        </div>

                                        <div className="mt-5 d-none">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Fatura No</label>
                                            <input style={{ border: '1px solid #F1F1F4' }} value={invoiceNo} type="text" className="form-control form-control-solid" disabled />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Miktar</label>
                                            <input style={{ border: '1px solid #F1F1F4' }} value={quantity} onChange={(e) => setQuantity(e.target.value)} type="number" className="form-control form-control-solid" />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Toplam Tutar</label>
                                            <input style={{ border: '1px solid #F1F1F4' }} value={(Helpers.toNumber(unitPrice) * Helpers.toNumber(quantity)).toFixed(2)} type="number" className="form-control form-control-solid" disabled />
                                        </div>

                                        {
                                            !Helpers.isEmpty(isApproved) && (
                                                <div className="mt-5">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label">Durum</label>
                                                    <div>
                                                        <i style={{ fontSize: 32 }} className={isApproved ? "text-success fa fa-check-circle" : "text-danger fa fa-times-circle"} />
                                                    </div>
                                                </div>

                                            )
                                        }

                                        <div className="mt-5 d-none">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Kur</label>
                                            <input style={{ border: '1px solid #F1F1F4' }} value={currency} type="number" className="form-control form-control-solid" disabled />
                                        </div>

                                        <div className="mt-5 d-none">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Fatura Tarihi</label>
                                            <input style={{ border: '1px solid #F1F1F4' }} value={invoiceDate} type="date" className="form-control form-control-solid" disabled />
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={expectedIncomes.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={expectedIncomes.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>


                        <Box onClick={expectedIncomes.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={expectedIncomes.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>

                        <Box title={fiyatBulIpucu} onClick={fiyatBulAktif ? () => setFiyatBulAcik(true) : undefined} opacity={fiyatBulAktif ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-info" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-search-dollar" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Fiyat Bul</span>
                            </Box>
                        </Box>
                    </Box>

                    <FindPriceModal
                        isShown={fiyatBulAcik}
                        ambarId={ambarId}
                        isIncome={isIncome}
                        mevcutSatirIdleri={expectedIncomes.map(x => x.ambarExpectedIncomeOutcomeId)}
                        onClose={() => setFiyatBulAcik(false)}
                        onSaved={fiyatSatirlariEklendi}
                    />

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                        <input onChange={selectAll} className='form-check-input' type='checkbox' checked={expectedIncomes.filter(x => x.isSelected).length > 0 && expectedIncomes.filter(x => x.isSelected).length == expectedIncomes.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Hizmet Kalemi</th>
                                            <th>Birim Fiyat</th>
                                            <th>Miktar</th>
                                            <th>Döviz Cinsi</th>
                                            <th>KDV %</th>
                                            <th>Toplam Tutar</th>
                                            <th>KDV Tutar</th>
                                            <th>Brüt Tutar</th>
                                            <th>Kur</th>
                                            <th>Açıklama</th>
                                            <th>Fatura No</th>
                                            <th>Fatura Tarihi</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            expectedIncomes.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            expectedIncomes.map((item, index) =>
                                                <tr style={{ background: item.invoiceId ? '#ffe1e1' : undefined }}>
                                                    <td style={{ width: 1 }}>
                                                        {
                                                            !item.invoiceId && (
                                                                <div className='d-flex'>
                                                                    <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                        <input onChange={() => setItemSelected(item.ambarExpectedIncomeOutcomeId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                    </label>
                                                                </div>
                                                            )
                                                        }
                                                    </td>
                                                    <td>{item.serviceName}</td>
                                                    <td className='custom-text-right'>{Helpers.correctPrice(item.unitPrice, 2)}</td>
                                                    <td className='custom-text-right'>{Helpers.correctPrice(item.quantity)}</td>
                                                    <td>{item.currencyTypeName}</td>
                                                    <td>{item.taxRate}</td>
                                                    <td className='custom-text-right'>{Helpers.correctPrice(item.totalWithoutTaxPrice, 2)}</td>
                                                    <td className='custom-text-right'>{Helpers.correctPrice(item.taxPrice, 4)}</td>
                                                    <td className='custom-text-right'>{Helpers.correctPrice(item.totalPrice, 2)}</td>
                                                    <td className='custom-text-right'>{Helpers.correctPrice(item.invoiceCurrency, 4)}</td>
                                                    {/* Sefer Fiyat Bul izi aciklamaya eklenir (kaynak siparis + tarih). */}
                                                    <td>{aciklamaVeSeferNotu(item)}</td>
                                                    <td>{item.transferInvoiceNo}</td>
                                                    <td>{Helpers.dateParser(item.invoiceDate)}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default AmbarExpectedIncomeOutcome;